import { Icon } from "materia"
import { modifiers } from "ui-tools"
import { getIsVideoUrl } from "../../dataUtilities/getIsVideoUrl"
import s from "./JourneyThumbnail.module.scss"

type JourneyThumbnailProps = {
  thumbnail?: string | null
  variant: "certified" | "locked" | "default"
}
export const JourneyThumbnail = ({
  thumbnail,
  variant = "default",
}: JourneyThumbnailProps) => {
  // A journey can be both locked and completed because reasons.
  // In this case the "locked" state should take precedence over the
  // "completed", because it still blocks the journeys depending on it.
  // If it's neither, show image passed as a prop if it exists
  const getThumbnailImage = () => {
    if (variant === "locked") return <Icon icon="Lock" />

    if (variant === "certified") return <Icon icon="Checkmark" />

    if (thumbnail && getIsVideoUrl(thumbnail)) {
      return (
        <video
          className={s.journeyThumbnail__image}
          src={thumbnail}
          muted
          playsInline
          preload="metadata"
          aria-hidden
          tabIndex={-1}
          onLoadedMetadata={(e) => {
            e.currentTarget.currentTime = 0.001
          }}
        />
      )
    }

    return (
      <div
        className={s.journeyThumbnail__image}
        style={thumbnail ? { backgroundImage: `url(${thumbnail})` } : {}}
      />
    )
  }

  return (
    <div className={modifiers(s, "journeyThumbnail", variant)}>
      {getThumbnailImage()}
    </div>
  )
}
